import { render, staticRenderFns } from "./VinData.vue?vue&type=template&id=0b0746da&scoped=true&"
import script from "./VinData.vue?vue&type=script&lang=js&"
export * from "./VinData.vue?vue&type=script&lang=js&"
import style0 from "./VinData.vue?vue&type=style&index=0&id=0b0746da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0746da",
  null
  
)

export default component.exports